import { render, staticRenderFns } from "./QuestionsRightRatio.vue?vue&type=template&id=880f9b9e&scoped=true&"
import script from "./QuestionsRightRatio.vue?vue&type=script&lang=js&"
export * from "./QuestionsRightRatio.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsRightRatio.vue?vue&type=style&index=0&id=880f9b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880f9b9e",
  null
  
)

export default component.exports